module.exports = __webpack_public_path__ + "img/index_logo.751363de.png";